import React, { Component, Fragment } from 'react';
import moment from 'moment';
import 'react-dates/initialize';
import { FormattedMessage } from 'react-intl';
import { object, func } from 'prop-types';

import { StatisticsDateFilterView } from '../index';

class StatisticsDateFilter extends Component {
  static propTypes = {
    startDate: object,
    endDate: object,
    onFilterChange: func.isRequired,
  };

  static defaultProps = {
    onFilterChange() {},
  };

  constructor(props) {
    super(props);

    this.state = {
      startDate: props.startDate ? props.startDate : null,
      endDate: props.endDate ? props.endDate : null,
      startDateLabel: '',
      endDateLabel: '',
      open: false,
      initialVisibleMonth: null,
    };
  }

  componentDidMount() {
    this.renderButtonLabel();
  }

  onDateChange = (date, name) => {
    this.setState(
      () => ({
        [name]: date,
      }),
      () => {
        const { startDate, endDate } = this.state;
        this.props.onFilterChange(startDate, endDate);
      },
    );
  };

  onDateApply = () => {
    this.props.onFilterApply();
    this.toggle();
    this.renderButtonLabel();
  };

  toggle = () => {
    this.setState(prevState => ({
      open: !prevState.open,
    }));
  };

  renderDatePresets = (presets = []) => {
    return (
      <Fragment>
        {presets.map(({ id, start, end }) => (
          <li key={id}>
            <button
              className="filter-datepicker-presets-btn"
              type="button"
              onClick={() =>
                this.onPeriodSelect({
                  startDate: start,
                  endDate: end,
                })
              }
            >
              <FormattedMessage id={`statistics.filters.presets.${id}`} defaultMessage={id} />
            </button>
          </li>
        ))}
      </Fragment>
    );
  };

  onPeriodSelect = ({ startDate, endDate }) => {
    this.props.onFilterChange(startDate, endDate);
    this.setState(
      () => ({ startDate, endDate }),
      () => {
        this.onDateApply();
      },
    );
  };

  renderButtonLabel = type => {
    const { startDate, endDate } = this.state;
    const startDateLabel = startDate ? startDate.format('DD.MM.YYYY') : '...';
    const endDateLabel = endDate ? endDate.format('DD.MM.YYYY') : '...';

    this.setState(() => ({ endDateLabel, startDateLabel }));
  };

  render() {
    const data = { ...this.state };
    return (
      <StatisticsDateFilterView
        data={data}
        toggle={this.toggle}
        onDateChange={this.onDateChange}
        onDateApply={this.onDateApply}
        renderDatePresets={this.renderDatePresets}
      />
    );
  }
}

export default StatisticsDateFilter;
